const monthDayFormat = new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
});

export function formatCheckedAgo(
    date: Date | null,
    style: "relative" | "date",
    now: Date = new Date(),
): string | null {
    if (!date) return null;

    if (style === "date") {
        return `Checked ${monthDayFormat.format(date)}`;
    }

    const mins = Math.floor((now.getTime() - date.getTime()) / 60000);
    if (mins < 1) return "updated just now";
    if (mins < 60) return `updated ${mins}m ago`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `updated ${hours}h ago`;
    const days = Math.floor(hours / 24);
    if (days === 1) return "updated yesterday";
    if (days < 7) return `updated ${days}d ago`;
    return `updated ${monthDayFormat.format(date)}`;
}
